// extracted by mini-css-extract-plugin
module.exports = {"arrow":"TechnologyTracker_arrow__1pneR","score":"TechnologyTracker_score__6x5HE","subCatName":"TechnologyTracker_subCatName__1GqJG"};